// extracted by mini-css-extract-plugin
module.exports = {"container":"FireflyImageSkeleton_container___CXUb","blink":"FireflyImageSkeleton_blink__C0IS1"};